import Notification from '@rio-cloud/rio-uikit/Notification';
import { useUpdateFreeTrialEligibilityMutation } from '../api/freetrial/freeTrialApiSlice';
import { getApiErrorMessage } from '../api/apiError';

type UpdateFreeTrialEligibilityPayload = {
    accountId: string;
    status: 'eligible' | 'ineligible';
    reason: string;
};

export function useUpdateFreeTrialEligibilityAction() {
    const [updateFreeTrialEligibility, { isLoading }] = useUpdateFreeTrialEligibilityMutation();

    const execute = async ({ accountId, status, reason }: UpdateFreeTrialEligibilityPayload) => {
        try {
            await updateFreeTrialEligibility({ accountId, status, reason }).unwrap();
            Notification.success(
                status === 'eligible' ? 'Free trial eligibility set successfully' : 'Free trial terminated successfully'
            );
            return true;
        } catch (e) {
            const errorMessage = getApiErrorMessage(e);
            Notification.error(`Could not execute free-trials service: ${errorMessage}`);
            return false;
        }
    };

    return {
        updateFreeTrialEligibility: execute,
        isLoading,
    };
}
